import { render, staticRenderFns } from "./DialogActiveAuthPackage.vue?vue&type=template&id=0d56adf8&scoped=true&"
import script from "./DialogActiveAuthPackage.vue?vue&type=script&lang=js&"
export * from "./DialogActiveAuthPackage.vue?vue&type=script&lang=js&"
import style0 from "./DialogActiveAuthPackage.vue?vue&type=style&index=0&id=0d56adf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d56adf8",
  null
  
)

export default component.exports